import gql from 'graphql-tag';
import { Query, QueryRegistry } from 'core/index';

export const AUTOCOMPLETE_TAGS = gql`
  query TagsComplete($complete: String) {
    channelComplete(complete: $complete) {
      id
      name
    }
  }
`;

export const AUTOCOMPLETE_TAGS_CONTAINS = gql`
  query Tag($complete: String, $first: Int) {
    channels(first: $first, contains: ["name", $complete]) {
      edges {
        node {
          id
          name
        }
      }
    }
  }
`;

// Could be auto-created from the form
export class CompleteTagsQuery extends Query {
  static conf = {
    GQL: AUTOCOMPLETE_TAGS,
    varNames: ['complete'],
    resultPath: 'channelComplete',
  };
}

QueryRegistry.add('tags.CompleteTagsQuery', CompleteTagsQuery);

export const AUTOCOMPLETE_SKILLS = gql`
  query SkillsAutocomplete($complete: String) {
    skillComplete(complete: $complete) {
      id
      content
      displayName
    }
  }
`;

export class AutocompleteSkillsQuery extends Query {
  static conf = {
    GQL: AUTOCOMPLETE_TAGS,
    varNames: ['complete'],
    resultPath: 'skillComplete',
  };
}

QueryRegistry.add('tags.AutocompleteSkillsQuery', AutocompleteSkillsQuery);
